(() => {
  if (window.VelvetFaqInitialized) return;
  window.VelvetFaqInitialized = true;

  const setItemOpen = (item, open) => {
    const button = item.querySelector("[data-velvet-faq-question]");
    const answer = item.querySelector("[data-velvet-faq-answer]");
    item.classList.toggle("is-open", open);
    button?.setAttribute("aria-expanded", String(open));
    if (answer) answer.hidden = !open;
  };

  const reveal = (root = document) => {
    const items = root.querySelectorAll(".velvet-faq-reveal:not([data-velvet-faq-ready])");
    if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      items.forEach((item) => item.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          currentObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    items.forEach((item) => {
      item.dataset.velvetFaqReady = "true";
      observer.observe(item);
    });
  };

  const initDirectory = (directory) => {
    if (directory.dataset.initialized === "true") return;
    directory.dataset.initialized = "true";

    const groups = [...directory.querySelectorAll("[data-velvet-faq-group]")];
    const items = [...directory.querySelectorAll("[data-velvet-faq-item]")];
    const pills = [...directory.querySelectorAll("[data-velvet-faq-category]")];
    const empty = directory.querySelector("[data-velvet-faq-empty]");
    const singleOpen = directory.dataset.singleOpen === "true";
    let activeCategory = "all";
    let searchTerm = "";

    const update = () => {
      let visibleTotal = 0;

      groups.forEach((group) => {
        const groupCategory = group.dataset.velvetFaqGroup;
        let visibleInGroup = 0;

        group.querySelectorAll("[data-velvet-faq-item]").forEach((item) => {
          const matchesCategory = activeCategory === "all" || groupCategory === activeCategory;
          const matchesSearch = !searchTerm || item.textContent.toLowerCase().includes(searchTerm);
          const visible = matchesCategory && matchesSearch;
          item.hidden = !visible;
          if (visible) {
            visibleInGroup += 1;
            visibleTotal += 1;
          } else {
            setItemOpen(item, false);
          }
        });

        group.hidden = visibleInGroup === 0;
      });

      if (empty) empty.hidden = visibleTotal !== 0;
    };

    items.forEach((item) => {
      const button = item.querySelector("[data-velvet-faq-question]");
      button?.addEventListener("click", () => {
        const willOpen = button.getAttribute("aria-expanded") !== "true";
        if (singleOpen && willOpen) items.forEach((other) => setItemOpen(other, false));
        setItemOpen(item, willOpen);
      });
    });

    pills.forEach((pill) => {
      pill.addEventListener("click", () => {
        activeCategory = pill.dataset.velvetFaqCategory;
        searchTerm = "";
        document.querySelectorAll("[data-velvet-faq-search]").forEach((input) => {
          input.value = "";
        });
        pills.forEach((other) => {
          const active = other === pill;
          other.classList.toggle("is-active", active);
          other.setAttribute("aria-pressed", String(active));
        });
        update();
      });
    });

    document.addEventListener("input", (event) => {
      if (!event.target.matches("[data-velvet-faq-search]")) return;
      searchTerm = event.target.value.trim().toLowerCase();
      activeCategory = "all";
      pills.forEach((pill) => {
        const active = !searchTerm && pill.dataset.velvetFaqCategory === "all";
        pill.classList.toggle("is-active", active);
        pill.setAttribute("aria-pressed", String(active));
      });
      update();
    });

    const hash = window.location.hash.slice(1);
    if (hash) {
      const target = items.find((item) => item.dataset.faqAnchor === hash);
      if (target) {
        setItemOpen(target, true);
        window.requestAnimationFrame(() => target.scrollIntoView({ behavior: "smooth", block: "center" }));
      }
    }

    update();
  };

  const init = (root = document) => {
    reveal(root);
    root.querySelectorAll("[data-velvet-faq-directory]").forEach(initDirectory);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
